/*
 * Zdarzenia lejka zamówienia (gtag). Tag Google ładuje się zawsze (Consent Mode v2,
 * public/index.html): bez zgody zdarzenie wychodzi jako ping bez cookies, ze zgodą
 * — normalnie. Zgodę stosuje consent.js.
 *
 * To zdarzenia POMOCNICZE (analiza lejka): nie są akcjami konwersji, więc Google
 * Ads ich nie optymalizuje. Jedyną konwersją pozostaje opłacone zamówienie
 * (CaseDetail.jsx). transport 'beacon' — zdarzenie przed przekierowaniem do
 * płatności musi zdążyć wyjść mimo opuszczenia strony.
 */
import { getConsent } from "./consent.js";

// Akcja konwersji „Zakup” (publiczny identyfikator, nie sekret). Zmienna środowiskowa
// pozwala ją podmienić bez zmiany kodu; wartość po || to obecna, działająca akcja.
const GADS_CONVERSION = process.env.REACT_APP_GADS_SEND_TO || "AW-18437670129/OgKfCMDGlPEcEPGJ4tdE";

const inflight = new Set(); // payments.id wysłane w tej sesji strony, dla których czekamy na potwierdzenie z tagu

/**
 * Konwersja Google Ads „Zakup” dla jednej potwierdzonej płatności. Wołana z każdego miejsca,
 * w którym widzimy opłaconą płatność (strona sprawy, a po powrocie klienta na dowolną stronę —
 * patrz App.js), więc zakup nie ginie, gdy klient nie wróci akurat na stronę sprawy.
 *
 * Bezpieczne wielokrotne wywołanie: transaction_id = payments.id (Google nie policzy tej samej
 * płatności dwa razy), flaga w localStorage + zestaw `inflight` ograniczają ponowne wysyłki.
 * Flagę zapisujemy dopiero w event_callback, czyli gdy tag faktycznie przetworzył zdarzenie —
 * zablokowany tag (adblock) nie ustawia flagi, więc następna wizyta spróbuje ponownie.
 * `ads` = hasze e-maila/telefonu z serwera, używane wyłącznie przy zgodzie (ad_user_data).
 */
export function reportGadsPurchase(p, ads) {
  try {
    if (!p || p.status !== "CONFIRMED" || !(p.amount_cents > 0)) return;
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const flag = `gtag_conv_payment_${p.id}`;
    if (inflight.has(p.id) || localStorage.getItem(flag)) return;
    inflight.add(p.id);

    if (getConsent() === true && ads) {
      const ud = {};
      if (ads.sha256_email_address) ud.sha256_email_address = ads.sha256_email_address;
      if (ads.sha256_phone_number) ud.sha256_phone_number = ads.sha256_phone_number;
      if (Object.keys(ud).length) window.gtag("set", "user_data", ud);
    }
    window.gtag("event", "conversion", {
      send_to: GADS_CONVERSION,
      value: p.amount_cents / 100,
      currency: "PLN",
      transaction_id: String(p.id),
      event_callback: () => {
        try {
          localStorage.setItem(flag, "1");
        } catch {
          /* storage zablokowany — najwyżej wyślemy ponownie, Google zdeduplikuje po transaction_id */
        }
      },
    });
  } catch {
    /* pomiar nigdy nie może zepsuć strony */
  }
}

export function track(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, { transport_type: "beacon", ...params });
    }
  } catch {
    /* pomiar nigdy nie może zepsuć zamówienia */
  }
}
